import { ReactNode } from "react";
import styles from "./ContactInfo.module.scss";

interface ContactInfoProps {
  name: ReactNode;
  value: ReactNode;
}

const ContactInfo = ({ name, value }: ContactInfoProps) => (
  <div className={styles.container}>
    <span className={styles.label}>{name}</span>
    <span className={styles.value}>{value}</span>
  </div>
);

export default ContactInfo;
